import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import UserDropdown from "../components/common/UserDropdown";
import NotificationBell from "../components/common/NotificationBell";
import { AuthContext } from "../context/AuthContext";
import "./custom.css"
import pig from "../staticfile/pig.png"
import flashcard from "../staticfile/flashcard.png"
export default function MainLayout() {
    const location = useLocation();
    const { logout, user } = useContext(AuthContext);
    const [open, setOpen] = useState(false);

    const current = location.pathname;
    const isActive = (path) => current.startsWith(path);
    const navigate = useNavigate();
    const handleClickLogo = () => {
        navigate("/");
    }
    return (
        <div className="app-layout">

            {/* ===== HEADER ===== */}
            <header className="app-header px-3 py-2 d-flex align-items-center justify-content-between shadow-sm bg-white">

                {/* LEFT */}
                <div className="d-flex align-items-center gap-2">

                    {/* Mobile toggle */}
                    <button
                        className={`btn btn-outline-secondary d-md-none menu-toggle ${open ? "active" : ""}`}
                        onClick={() => setOpen(v => !v)}
                        aria-expanded={open}
                        aria-label="Toggle sidebar"
                    >
                        <i className={`bi ${open ? "bi-x-lg" : "bi-list"}`} />
                    </button>

                    {/* Logo + Brand */}
                    <div className="d-flex align-items-center gap-2 app-brand" onClick={handleClickLogo}>
                        <img
                            src={flashcard}
                            alt="FlashCard logo"
                            className="app-logo"
                        />
                        <span className="app-name d-none d-sm-inline">
                            FlashCard
                        </span>
                    </div>
                </div>

                {/* CENTER */}
                <div className="flex-grow-1 ms-3">
                    {/* <TopPathBar /> */}
                </div>

                {/* RIGHT */}
                <div className="d-flex align-items-center gap-2">
                    <NotificationBell />
                    <UserDropdown
                        user={{
                            name: user?.email || user?.name || "User",
                            avatar: pig
                        }}
                        onLogout={logout}
                    />
                </div>
            </header>


            {/* ===== BODY ===== */}
            <div className="app-body">

                {/* ===== SIDEBAR ===== */}
                <aside
                    className={`app-sidebar p-3 d-flex flex-column ${open ? "open" : ""}`}
                >
                    <h5 className="mb-3">Services</h5>

                    <ul className="nav flex-column">
                        <li className="nav-item mb-1">
                            <Link
                                to="/category"
                                className={`nav-link ${isActive("/category") ? "active fw-bold" : ""}`}
                                onClick={() => setOpen(false)}
                            >
                                Category
                            </Link>
                        </li>

                        <li className="nav-item mb-1">
                            <Link
                                to="/flashcard"
                                className={`nav-link ${isActive("/flashcard") ? "active fw-bold" : ""}`}
                                onClick={() => setOpen(false)}
                            >
                                Flashcards
                            </Link>
                        </li>

                        <li className="nav-item mb-1">
                            <Link
                                to="/review"
                                className={`nav-link ${isActive("/review") ? "active fw-bold" : ""}`}
                                onClick={() => setOpen(false)}
                            >
                                Reviews
                            </Link>
                        </li>

                        <li className="nav-item mb-1">
                            <Link
                                to="/exam"
                                className={`nav-link ${isActive("/exam") ? "active fw-bold" : ""}`}
                                onClick={() => setOpen(false)}
                            >
                                Exams
                            </Link>
                        </li>
                         <li className="nav-item mb-1">
                            <Link
                                to="/genimage"
                                className={`nav-link ${isActive("/genimage") ? "active fw-bold" : ""}`}
                                onClick={() => setOpen(false)}
                            >
                                Jobs
                            </Link>
                        </li>
                    </ul>
                </aside>

                {/* ===== MAIN CONTENT ===== */}
                <main className="app-main">
                    <Outlet />
                </main>

            </div>
        </div>
    );
}
